import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ResidencyStatusService from "../../src/Services/ResidencyStatus.service";
import LookupGeneric from "./lookupGeneric";
const ResidencyStatusLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            return ResidencyStatusService.findByIds(ids);
        },
        fetchOptions: (query) => {
            return ResidencyStatusService.search({
                query,
                active: true, // if ResidencyStatus has an active field for this purpose
            }).then(({ data }) => data);
        },
        optionRenderer: function optionRenderer(residencyStatus) {
            return _jsx("span", { children: residencyStatus.name });
        },
    });
};
export default ResidencyStatusLookup;
